import React, { useEffect, useState, useRef } from 'react';
import { ChevronLeft, ChevronRight, Eye } from 'lucide-react';
const previewImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/fMrFGv5wNBi1WngXfQbBa6/Diseno_sin_titulo-46.png',
  alt: 'Clase 2: El sufragio en Argentina'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/tfKBjtcDwyxkqUiw9YcU64/Diseno_sin_titulo-45.png',
  alt: 'Desarrollo: El Estado'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/t7VMPGmCox7UnSUXu1fRe4/Diseno_sin_titulo-44.png',
  alt: 'Evaluación grupal colaborativa'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5FMX7AkD6h2pGQWYbqqxCL/Diseno_sin_titulo-43.png',
  alt: 'Derecho público y privado'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/r5QUhDovFtqbXyP44eKCdC/Diseno_sin_titulo-42.png',
  alt: 'Forma de gobierno: República federal'
}];
export function PreviewCarousel() {
  const [current, setCurrent] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [translateX, setTranslateX] = useState(0);
  const trackRef = useRef<HTMLDivElement>(null);
  const total = previewImages.length;
  const goTo = (index: number) => {
    if (index < 0) setCurrent(total - 1);else if (index >= total) setCurrent(0);else setCurrent(index);
  };
  const handleTouchStart = (e: React.TouchEvent) => {
    setIsDragging(true);
    setStartX(e.touches[0].clientX);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    if (!isDragging) return;
    const diff = e.touches[0].clientX - startX;
    setTranslateX(diff);
  };
  const handleTouchEnd = () => {
    setIsDragging(false);
    if (translateX > 50) goTo(current - 1);else if (translateX < -50) goTo(current + 1);
    setTranslateX(0);
  };
  // Auto-advance every 4 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % total);
    }, 4000);
    return () => clearInterval(timer);
  }, [total]);
  return <section className="py-16 bg-slate-50" data-id="element-62">
      <div className="container mx-auto px-4" data-id="element-63">
        <div className="max-w-4xl mx-auto" data-id="element-64">
          {/* Header */}
          <div className="text-center mb-10" data-id="element-65">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-900 text-amber-400 rounded-full text-sm font-semibold mb-4" data-id="element-66">
              <Eye className="h-4 w-4" data-id="element-67" />
              <span data-id="element-68">MIRÁ POR DENTRO</span>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-2" data-id="element-69">
              Páginas reales del material
            </h3>
            <p className="text-slate-600 max-w-xl mx-auto" data-id="element-70">
              Proyectos paso a paso, clases listas y actividades prácticas
            </p>
          </div>

          {/* Carousel */}
          <div className="relative" data-id="element-71">
            {/* Main image area */}
            <div className="overflow-hidden rounded-2xl border border-slate-200 shadow-lg bg-white" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} ref={trackRef} data-id="element-72">
              <div className="flex transition-transform duration-500 ease-out" style={{
              transform: `translateX(calc(-${current * 100}% + ${translateX}px))`
            }} data-id="element-73">
                {previewImages.map((img, i) => <div key={i} className="w-full flex-shrink-0" data-id="element-74">
                    <img src={img.src} alt={img.alt} className="w-full h-auto" draggable={false} data-id="element-75" />
                  </div>)}
              </div>
            </div>

            {/* Navigation arrows */}
            <button onClick={() => goTo(current - 1)} className="absolute left-2 md:-left-5 top-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-lg border border-slate-200 flex items-center justify-center hover:bg-slate-50 transition-colors z-10" aria-label="Anterior" data-id="element-76">
              <ChevronLeft className="h-5 w-5 text-slate-700" data-id="element-77" />
            </button>
            <button onClick={() => goTo(current + 1)} className="absolute right-2 md:-right-5 top-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-lg border border-slate-200 flex items-center justify-center hover:bg-slate-50 transition-colors z-10" aria-label="Siguiente" data-id="element-78">
              <ChevronRight className="h-5 w-5 text-slate-700" data-id="element-79" />
            </button>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-6" data-id="element-80">
            {previewImages.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`h-2 rounded-full transition-all duration-300 ${i === current ? 'w-8 bg-blue-900' : 'w-2 bg-slate-300 hover:bg-slate-400'}`} aria-label={`Ir a imagen ${i + 1}`} data-id="element-81" />)}
          </div>

          {/* Caption */}
          <p className="text-center text-sm text-slate-500 mt-4" data-id="element-82">
            {current + 1} de {total} — {previewImages[current].alt}
          </p>
        </div>
      </div>
    </section>;
}